/**
 * @generated SignedSource<<8ff8a16a0bcc9abd1a27e939d9b4ea35>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PlansList$data = {
  readonly jira: {
    readonly favouritePlans: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id?: string;
          readonly planId?: AGG$Long | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"PlanMenuItem">;
        };
      } | null | undefined> | null | undefined;
    };
    readonly recentPlans: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id?: string;
          readonly planId?: AGG$Long | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"PlanMenuItem">;
        };
      } | null | undefined> | null | undefined;
    };
  };
  readonly " $fragmentType": "PlansList";
} | null | undefined;
export type PlansList$key = {
  readonly " $data"?: PlansList$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlansList">;
};

import PlanListQuery_graphql from './PlanListQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "planId"
},
v3 = {
  "kind": "FragmentSpread",
  "name": "PlanMenuItem"
},
v4 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentURLPath"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": PlanListQuery_graphql
    }
  },
  "name": "PlansList",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "favouritePlans",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "filter",
                  "value": {
                    "sort": {
                      "order": "DESC"
                    },
                    "type": "PLAN"
                  }
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 15
                }
              ],
              "concreteType": "JiraFavouriteConnection",
              "kind": "LinkedField",
              "name": "favourites",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraFavouriteEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v1/*: any*/),
                                "action": "LOG",
                                "path": "jira.favouritePlans.edges.node.id"
                              },
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ],
                            "type": "JiraPlan"
                          }
                        ]
                      },
                      "action": "LOG",
                      "path": "jira.favouritePlans.edges.node"
                    }
                  ]
                },
                (v4/*: any*/)
              ]
            },
            "action": "LOG",
            "path": "jira.favouritePlans"
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": "recentPlans",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "currentURL",
                  "variableName": "currentURLPath"
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 20
                },
                {
                  "kind": "Literal",
                  "name": "types",
                  "value": [
                    "PLAN"
                  ]
                }
              ],
              "concreteType": "JiraSearchableEntityConnection",
              "kind": "LinkedField",
              "name": "recentItems",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraSearchableEntityEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v1/*: any*/),
                                "action": "LOG",
                                "path": "jira.recentPlans.edges.node.id"
                              },
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ],
                            "type": "JiraPlan"
                          }
                        ]
                      },
                      "action": "LOG",
                      "path": "jira.recentPlans.edges.node"
                    }
                  ]
                },
                (v4/*: any*/)
              ]
            },
            "action": "LOG",
            "path": "jira.recentPlans"
          }
        ]
      },
      "action": "LOG",
      "path": "jira"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "e819441248aed1e08c25170c0c3e028c";

export default node;
